import * as types from './mutation-types'

export default  {
  [types.INCRECEMENT] (state) {
    state.count++
  },
  [types.TOGGLE_POPUP] (state) {
    state.popupVisible = !state.popupVisible
  },
  [types.CLOSE_POPUP] (state){
    state.popupVisible = false;

  },
  [types.SET_POPUP] (state,val){
    // state.popupVisible = false;
    state.popupVisible = val;

  },
  [types.SUBMIT_KEYWORD] (state, keyword) {
    state.keyword = keyword
  },
  [types.SET_SCROLL] (state, scrollTop) {
    state.scrollTop = scrollTop
  },
  [types.SET_LOADING] (state, val) {
    state.loadingShow = val
  },
  [types.SAVE_AUTH] (state, val) {
    state.auth = val
  },
  [types.SAVE_NAME] (state, val) {
    state.user.name = val
  },
  [types.SET_USER] (state, {auth ,auth2,name,userId}) {
    state.user = {
      auth,
      auth2,
      name,
      userId
    }
  },
  [types.SAVE_USERINFO] (state, res) {
    for(var i in res){
      state.user[i] = res[i];
    }
  },
  [types.UPDATE_MESSAGE] (state, payload) {
    state.authInfo[payload.type] = payload.val;
  },
  [types.SYNC_AUTHINFO] (state, payload) {
    for (var i in payload){
      state.authInfo[i] = payload[i];
    }

  },
  [types.SAVE_USERINFOALL] (state, res) {
    state.userInfo = res;
  },
  [types.SAVE_PRIVI] (state, payload) {
    console.log("commit 钩子");
    console.log(payload);
    state.privilageInfo = payload;
  },
  [types.SAVE_LIVEURL] (state, payload) {
    // console.log(payload)
    state.originLiveUrl = payload;
  },
  [types.SAVE_JHOS] (state, payload) {
    state.jurisdictionHospital = payload;
  },
  [types.SAVE_JRNAME] (state, payload) {
    console.log("重置 realname");
    state.jurisdictionRealName = payload;
  },
  [types.SAVE_JDEPTNAME] (state, payload) {
    state.jurisdictionDeptName = payload;
  },
  [types.SAVE_JUNI] (state, payload) {
    state.jurisdictionUniversityName = payload;
  },
  [types.SAVE_JMAJOR] (state, payload) {
    state.jurisdictionmajorName = payload;
  },
  [types.SAVE_JDOCID] (state, payload) {
    state.jurisdictionDocid = payload;
  },
  [types.SAVE_JDOCTYPE] (state, payload) {
    state.jurisdictionDoctype = payload;
  },
  [types.SAVE_JPATH] (state, payload) {
    state.jurisdictionpath = payload;
  },


  [types.SAVE_APROGRESS] (state, payload) {
    state.audioprogress = payload;
  },

  [types.SAVE_CASEID] (state, payload) {
    state.caseId = payload;
  },

  [types.SAVE_AZITEMS] (state, payload) {
    state.AZitems = payload;
  },


  [types.SAVE_ANSWERRECORDID] (state, payload) {
    state.answerRecordId = payload;
  },
  [types.SAVE_DOC_FOCUS_COLUMN] (state, payload) {
    state.focuscolumns = payload;
  },
  [types.SAVE_WHITE_MOBILE_LIST] (state, payload) {
    state.docmobiles = payload;
  },

  [types.SAVE_ISRIGISTER] (state, payload) {
    state.isRigisterTwo = payload;
  },

  [types.SQSM_FILTER_JSON] (state, payload) {
    state[types.SQSM_FILTER_JSON] = payload;
  },


  [types.SYNC_PRESONALINFO] (state, payload) {
    for (let i in payload){
      state.personalInfo[i] = payload[i];
    }
  },
  [types.UPDATE_PRESONALINFO] (state, payload) {
    state.personalInfo[payload.type] = payload.val;
  },
  [types.SAVE_ISCOMPLETE] (state, payload) {
    state.iscomplete = payload;
  },
  [types.SAVE_COMPLETEPATH] (state, payload) {
    state.completepath = payload;
  },
  [types.SAVE_onlyLackDisease] (state, payload) {
    state.onlyLackDisease = payload;
  },
  [types.UPDATE_EDCSOURCEDATA] (state, payload) {
    state.EDCSourceData[payload.type] = payload.val;
  },
  [types.UPDATE_EDCSOURCEPATIENT] (state, payload) {
    for (let i in payload){
      state.EDCpatient[i] = payload[i];
    }
  },
  [types.UPDATE_EDCSUBPROJECTCODE] (state, payload) {
    for (let i in payload){
      state.EDCSubproject[i] = payload[i];
    }
  },
  [types.SAVE_EDCDOCTORINFO] (state, payload) {
    for (let i in payload){
      state.EDCDoctorInfo[i] = payload[i];
    }
  },
  [types.UPDATE_EDCDOCTORINFO_ITEM] (state, payload) {
    state.EDCDoctorInfo[payload.type] = payload.val;
  },
  [types.UPDATE_EDCDOCTORINFO_BANK_ITEM] (state, payload) {
    state.EDCDoctorInfo.bankInfo[payload.type] = payload.val;
  },
  [types.SAVE_IHAPPLYINFO] (state, payload) {
    for (let i in payload){
      state.IHApplyUserInfo[i] = payload[i];
    }
  },
  [types.UPDATE_IHAPPLYINFO_ITEM] (state, payload) {
    state.IHApplyUserInfo[payload.type] = payload.val;
  },
  [types.CUSTOM_LIMITTIME_TASK] (state, payload) {
    state.customLimitTimeTask = payload;
  },
  [types.SAVE_CONFIGWX_INFO] (state, payload) {
    state.configWxData = payload;
  },
}
